import QuoteList from './quote-list.container';
import * as Navigations from '../../constants/navigations';
const { path } = Navigations.QUOTE_LIST;
export default [{ path, name: 'QuoteList', component: QuoteList, exact: true }];
